<div class="pii-field-container">
  <div class="pii-field-label" *ngIf="showLabel && label">
    <label class="form-label">{{ label }}</label>
  </div>
  
  <div class="pii-field-content">
    <div class="pii-value-container">
      <span class="pii-value" [class.masked]="!isUnmasked" [class.unmasked]="isUnmasked">
        {{ displayValue }}
      </span>
      
      <div class="pii-actions">
        <button 
          *ngIf="canUnhide" 
          type="button" 
          class="btn btn-sm btn-outline-primary pii-unmask-btn"
          (click)="onUnhide()"
          [disabled]="isLoading"
          title="Unmask All PII Fields">
          <img src="assets/images/unmask-icon.png" alt="Unmask" style="width: 16px; height: 16px;" *ngIf="!isLoading">
          <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
        
        <button 
          *ngIf="isUnmasked" 
          type="button" 
          class="btn btn-sm btn-outline-secondary pii-mask-btn"
          (click)="onHide()"
          title="Mask All PII Fields">
          <i appFeatherIcon data-feather="eye-off"></i>
        </button>
<!--         
        <button 
          *ngIf="isUnmasked" 
          type="button" 
          class="btn btn-sm btn-outline-info pii-copy-btn"
          (click)="onCopy()"
          title="Copy to Clipboard">
          <i appFeatherIcon data-feather="copy"></i>
        </button> -->
      </div>
    </div>
    
    <!-- <div class="pii-security-notice" *ngIf="isUnmasked">
      <small class="text-muted">
        <i appFeatherIcon data-feather="shield"></i>
        This PII access has been logged for audit purposes
      </small>
    </div> -->
  </div>
</div> 